import React from 'react';
import { Button, FilterToolbar } from '@mts/ui';
import { directoryCategoryOptions } from '../../utils/directoryCategories.js';
import { List, Map } from 'lucide-react';

/**
 * FilterBar
 * Reusable filter and sort controls for business directory and similar pages.
 * 
 * @param {Array} categories - Array of category objects with { id, slug, name }
 * @param {string} categoryValue - Currently selected category
 * @param {Function} onCategoryChange - Callback for category changes
 * @param {string} sortValue - Currently selected sort option
 * @param {Function} onSortChange - Callback for sort changes
 * @param {boolean} openOnlyValue - Whether "open only" is checked
 * @param {Function} onOpenOnlyChange - Callback for "open only" toggle
 * @param {number} resultCount - Number of filtered results (for display)
 */
function FilterBar({
  resultCount = 0,
  categories = [],
  categoryValue = 'all',
  onCategoryChange,
  viewMode = 'list',
  onViewModeChange,
}) {
  return (
    <FilterToolbar
      compact
      className="rounded-2xl border-base-300 bg-base-100/85"
      actions={[
        <div key="view-mode" className="join" role="group" aria-label="View mode">
          <Button
            type="button"
            size="sm"
            variant={viewMode === 'list' ? 'primary' : 'outline'}
            className="join-item"
            aria-pressed={viewMode === 'list'}
            onClick={() => onViewModeChange?.('list')}
          >
            <List className="h-4 w-4" aria-hidden="true" />
            List
          </Button>
          <Button
            type="button"
            size="sm"
            variant={viewMode === 'map' ? 'primary' : 'outline'}
            className="join-item"
            aria-pressed={viewMode === 'map'}
            onClick={() => onViewModeChange?.('map')}
          >
            <Map className="h-4 w-4" aria-hidden="true" />
            Map
          </Button>
        </div>
      ]}
    >
      <label className="flex flex-col gap-1 text-sm">
        Category
        <select className="rounded-md border border-base-300 bg-base-100 p-2" value={categories.find(category => [category.id, category.slug, category.name].includes(categoryValue))?.slug || categoryValue} onChange={event => onCategoryChange?.(event.target.value)}>
          <option value="all">All categories</option>
          {directoryCategoryOptions(categories).map(category => <option key={category.id} value={category.slug}>{'\u00a0\u00a0'.repeat(category.depth)}{category.name}</option>)}
          {categoryValue !== 'all' && !categories.some(category => [category.id, category.slug, category.name].includes(categoryValue)) && <option value={categoryValue}>{categoryValue}</option>}
        </select>
      </label>
      <span className="text-xs text-base-content/70">
        {resultCount} result{resultCount === 1 ? '' : 's'}
      </span>
    </FilterToolbar>
  );
}

export default FilterBar;
